import createAction from '../../common/services/create-action';

export const SET_POST_TYPE_FILTER = 'SET_POST_TYPE_FILTER';
export const setPostTypeFilter = createAction(SET_POST_TYPE_FILTER);

export const SET_CATEGORY_FILTER = 'SET_CATEGORY_FILTER';
export const setCategoryFilter = createAction(SET_CATEGORY_FILTER);
